import React from "react";
import {Controller} from "react-hook-form";
import {RadioInputGroup} from "./RadioGroup";

interface FormRadioInputGroupProps {
    control: any;
    name: string;
    checked?: boolean;
    defaultValue?: string | number;
    children: React.ReactNode;
}

export const FormRadioInputGroup = ({defaultValue, name, control, children}: FormRadioInputGroupProps) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, ...rest }) => {
                return (
                    <RadioInputGroup
                        defaultValue={defaultValue}
                        name={field.name}
                        value={field.value}
                        onChange={field.onChange}
                        errorMessage={rest.formState.errors[name]?.message as string || ''}
                    >
                        {children}
                    </RadioInputGroup>
                )
            }}
        />
    );
}